import React, { useContext } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import Flag from '@wix/da-react-context/pkg/flags/Flag';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { DeviationLink } from '../../../Duperbrowse';
import useBiDataForDeviationLink from '../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import TierPromotionCard from '../../TierPromotionCard';
import TierPromotionCardWithFellaTooltip from '../../TierPromotionCardWithFellaTooltip';
import { ViewerContainerSizeContext } from '../../../DaEditorWrapper/ViewerContainerSizeContext/ViewerContainerSizeContext';
import s from './Tier.scss';
var TierFeedCardContents = function (_a) {
    var deviation = _a.deviation, width = _a.width, className = _a.className, showTierPromotionTooltip = _a.showTierPromotionTooltip;
    // TODO: refactor this away
    var layoutWidth = useContext(ViewerContainerSizeContext);
    var biData = useBiDataForDeviationLink(deviation);
    return (React.createElement("div", { className: classnames(s['root'], className) },
        showTierPromotionTooltip ? (React.createElement(TierPromotionCardWithFellaTooltip, { deviation: deviation, width: width !== null && width !== void 0 ? width : layoutWidth, isPostsFeedCard: true })) : (React.createElement(TierPromotionCard, { deviation: deviation, width: width !== null && width !== void 0 ? width : layoutWidth })),
        React.createElement(Flag, { condition: "tier_promo_profile", render: function () { return (React.createElement(BiLink, { className: s['link-overlay'], biData: biData, href: Url.userSubscriptionsPath({
                    username: deviation.author.username,
                    tierDeviationId: deviation.deviationId,
                    tierContentType: 'deviations',
                }) },
                React.createElement("span", null))); }, fallbackRender: function () { return (React.createElement(DeviationLink, { deviation: deviation, className: s['link-overlay'], title: deviation.title },
                React.createElement("span", null))); } })));
};
TierFeedCardContents.displayName = 'TierFeedCardContents';
export default TierFeedCardContents;
//# sourceMappingURL=Tier.js.map